import { FC } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import { BodyText, Stack, Icon, Form, Label } from '@servicetitan/design-system';
import { NumberInput } from '@servicetitan/form';
import { CostField } from '../stores/campaign-cost-drawer.store';
import * as Styles from './cost-inputs.module.less';

interface CostInputsProps {
    title: string;
    qaPrefix?: string;
    value: CostField;
}

export const CostInputs: FC<CostInputsProps> = observer(({ title, qaPrefix, value }) => {
    return (
        <div className={classnames(qaPrefix)}>
            <BodyText bold size="medium" className={classnames(`${qaPrefix}-title`, 'm-b-1')}>
                {title}
            </BodyText>
            <Stack alignItems="flex-end">
                <Stack.Item grow={1} shrink={1}>
                    <Form.Field>
                        <Label className="m-b-half fw-normal">Avg Daily Cost</Label>
                        <NumberInput
                            shortLabel="$"
                            value={value.$.day.value}
                            onChange={value.onDayChange}
                            qa-testing={`${qaPrefix}-input-day`}
                            className={Styles.input}
                            emptyValue={0}
                            decimalPlaces={2}
                            min={0}
                        />
                    </Form.Field>
                </Stack.Item>
                <div className={Styles.arrowWrapper}>
                    <Icon name="arrow_forward" className="m-x-2 c-neutral-100" size={20} />
                </div>
                <Stack.Item grow={1} shrink={1}>
                    <Form.Field>
                        <Label className="m-b-half fw-normal">
                            Monthly Cost{' '}
                            <BodyText inline size="small" subdued>
                                ({value.daysCount} days)
                            </BodyText>
                        </Label>
                        <NumberInput
                            shortLabel="$"
                            value={value.$.month.value}
                            onChange={value.onMonthChange}
                            qa-testing={`${qaPrefix}-input-month`}
                            className={Styles.input}
                            emptyValue={0}
                            decimalPlaces={2}
                            min={0}
                        />
                    </Form.Field>
                </Stack.Item>
            </Stack>
        </div>
    );
});
